<ng-container>
    <div class="loading-container" *ngIf="show && !displayCancel">
        <div class="loading-icon">
            <img src="assets/icons/loading.svg" alt="loading">
        </div>
    </div>
</ng-container>
